'use strict';

const ACTION_TO_READ = 'READ';
const ACTION_TO_MANAGE = 'MANAGE';
const ACTION_TO_TRACKING = 'READ_TRACKING';
const ACTION_TO_EDIT_DELETE = 'EDIT_DELETE';
const ACTION_TO_VIEW_STOCK = 'CAN_VIEW_STOCK';
const ACTION_TO_EDIT_DENSTIY = 'CAN_CHANGE_DENSITY';
const ACTION_TO_EDIT_PRODUCTIVITY = 'CAN_CHANGE_PRODUCTIVITY';
const ACTION_TO_CHECK_MAQUINAS = 'CAN_VALIDATE_CHECK';
const ACTION_TO_INTEGRACAO_PLUVIOMETROS = 'INTEGRACAO_PLUVIOMETROS';
const ROLE_ESTOQUE = 212;
const ROLE_CONTAGEM = 204;
const ROLE_MAQUINAS = 216;
const ROLE_CLIMA = 219;

const ROLES = {
  204: 'contagem',
  207: 'ocorrencia',
  208: 'recomendacao',
  220: 'recomendacaoSemeadura',
  210: 'anotacao',
  209: 'pulverizacao',
  211: 'tarefa',
  212: 'estoque',
  216: 'maquina',
  218: 'demarcacaoArea',
  231: 'correcaoSolo',
  234: 'adubacao',
  226: 'plantio',
  219: 'clima',
  245: 'mapas',
  parameters: 'parametro',
  roles: 'funcao',
  users: 'usuario',
  visits_panel: 'painelVisita',
  users_panel: 'painelUsuario',
  visits_report: 'relatorioVisita',
  depositos: 'depositos',
  produtividade: 'produtividade',
  tipos_ocorrencia: 'tipos_ocorrencia',
  propriedades: 'propriedades',
  itens_estoque: 'itens_estoque',
  colheitas: 'colheitas',
  colheita_afericao: 'colheita_afericao',
  semeadura_afericao: 'semeadura_afericao',
  241: 'usosMaquinas',
  contratos: 'contratos',
  aplicacao_afericao: 'aplicacao_afericao',
  recomendacao_correcao_solo: 'recomendacaoCorrecaoSolo',
  recomendacao_adubacao_cobertura: 'recomendacaoAdubacaoCobertura'
};

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('PermissionsService', function() {
  const canManage = function(acoes) {
    return acoes.indexOf(ACTION_TO_MANAGE) >= 0;
  };

  const canRead = function(acoes) {
    return acoes.indexOf(ACTION_TO_READ) >= 0 || canManage(acoes);
  };

  const canDoAction = function(acoes, action) {
    return acoes.includes(action);
  };

  return {
    // eslint-disable-next-line max-lines-per-function
    get: function(roles) {
      const ret = (roles || []).reduce(function(map, role) {
        map[ROLES[role.id] || role.id] = role;
        role.acoes = ''.toUpperCase.apply(role.acoes).split(',');
        role.canRead = canRead(role.acoes);
        role.canManage = canManage(role.acoes);
        role.canReadTracking = canDoAction(role.acoes, ACTION_TO_TRACKING);
        role.canEditDelete = canDoAction(role.acoes, ACTION_TO_EDIT_DELETE);

        if (role.id === ROLE_ESTOQUE) {
          role.canViewStock = canDoAction(role.acoes, ACTION_TO_VIEW_STOCK);
        }

        if (role.id === ROLE_CONTAGEM) {
          role.canEditDensity = canDoAction(role.acoes, ACTION_TO_EDIT_DENSTIY);
          role.canEditProductivity = canDoAction(role.acoes, ACTION_TO_EDIT_PRODUCTIVITY);
        }

        if (role.id === ROLE_MAQUINAS) {
          role.canCheck = canDoAction(role.acoes, ACTION_TO_CHECK_MAQUINAS);
        }

        if (role.id === ROLE_CLIMA) {
          role.integracaoPluviometros = canDoAction(role.acoes, ACTION_TO_INTEGRACAO_PLUVIOMETROS);
        }

        role.acoes.forEach(function(acao) {
          role[acao] = true;
        });
        return map;
      }, {});

      /* Adiciona todas permissões sem as roles para evitar NPE */
      for (const role in ROLES) {
        if (!ret[ROLES[role]]) {
          ret[ROLES[role]] = {};
        }
      }

      /* Se poder gerenciar pode visualizar as auditorias */
      ret.usuario.CAN_VIEW_AUDITS =
        ret.usuario.CAN_VIEW_AUDITS || ret.usuario.CAN_APROVE_RECOMMENDATION || ret.usuario.CAN_AUDIT_PULVERIZATION;

      return ret;
    }
  };
});
